import { useState } from 'react'
import { Helmet } from 'react-helmet'
import CreditsInfo from '../../../components/CreditsInfo'
import PanelSwitch from '../../../components/PanelSwitch'
import RoomsCalendar from '../../../containers/RoomsCalendar'
import SpacesCalendar from '../../../containers/SpacesCalendar'


const ReservationsUserPanel = () => {
  const [tab, setTab] = useState('spaces')

  const changeTab = (tab) => {
    setTab(tab)

    if(tab !== 'spaces') {
      const interval = setInterval(() => {
        const container = document.querySelector('.ReservationsUserPanel')
        container.scrollTo(0, 1000)
        if(container.offsetTop !== 0) clearTimeout(interval)
      }, 100)
    }
  }

  return (
    <>
      <Helmet>
        <title>Vida Cowork: Reservas</title>
      </Helmet>

      <main className="ReservationsUserPanel panel-main panel-main--table d-flex flex-column gap-3 pt-3">
        <CreditsInfo className="d-xxl-none" />

        <PanelSwitch tab={tab} changeTab={changeTab}/>

        {tab === 'spaces'
          ? <SpacesCalendar/>
          : <RoomsCalendar/>
        }
      </main>
    </>
  )
}

export default ReservationsUserPanel